import { ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { UserType } from 'hooks/useUserData';

export const isTaskAssignedToMe = ({ task, user }: { task: ArticleType; user: UserType }) => {
  return task.taskOwner?.toLowerCase() === user?.username?.toLowerCase();
};

export const isTaskAssignedToOthers = ({ task, user }: { task: ArticleType; user: UserType }) => {
  return (
    task.createdBy?.toLowerCase() === user?.username?.toLowerCase() &&
    task.taskOwner?.toLowerCase() !== user?.username?.toLowerCase()
  );
};
